import Sidebar from "@/components/Sidebar";
import WorkspaceSwitcher from "@/components/WorkspaceSwitcher";
import { useAuth } from "@/context/AuthContext";
import { Bell, Search } from "lucide-react";

export default function FinanceLayout({ children }) {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-white">
      <Sidebar />
      <div className="ml-[280px] min-h-screen">
        <header className="sticky top-0 z-30 bg-white border-b border-slate-100 h-16 flex items-center justify-between px-8" data-testid="finance-header">
          <div />
          <WorkspaceSwitcher />
          <div className="flex items-center gap-4">
            <button type="button" className="text-slate-400 hover:text-slate-700 transition-colors" data-testid="hdr-search">
              <Search size={18} />
            </button>
            <button type="button" className="text-slate-400 hover:text-slate-700 transition-colors relative" data-testid="hdr-notif">
              <Bell size={18} />
            </button>
            <div className="flex items-center gap-2 pl-2">
              <div className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center font-semibold text-xs">
                {(user?.name || "?").slice(0, 1).toUpperCase()}
              </div>
              <div className="text-sm">
                <div className="font-semibold text-slate-900 leading-tight">{user?.name || "-"}</div>
                <div className="text-xs text-slate-500">Admin</div>
              </div>
            </div>
          </div>
        </header>
        <main className="p-8 2xl:p-10" data-testid="finance-main">
          <div className="max-w-[1320px]">{children}</div>
        </main>
      </div>
    </div>
  );
}
